import React, { useState, useContext, useEffect } from 'react';
import PropTypes from 'prop-types';
import { UserContext } from 'providers/user.provider';
import { useDispatch, useSelector } from 'react-redux';
import { compose } from 'redux';
import injectSaga from 'redux-utils/injectSaga';
import injectReducer from 'redux-utils/injectReducer';
import WithApa from 'newComponents/WithApa/WithApa';
import { GetRegion } from 'constants.js';
import { setRegion } from 'utils/Region';
import { actions as getUserInfoActions } from 'action-creators/user/getUserInfo';
import { setMetricsEvent } from 'action-creators/metrics';
import Loader from 'components/Loader';
import { Button } from 'cvlib';
import { FaChevronLeft } from 'react-icons/fa';
import Promotions from './components/Promotions';
import TermsAndConditions from './components/TermsAndConditions';
import saga from '../User/saga';
import reducer from '../User/reducer';
import { actionUserRegister } from '../User/actions';
import { METRICS as m } from './constants';
import './Register.scss';

import { EmailForm, PasswordForm } from './components';
import {
  useNavigate,
  useSearchParams,
  useLocation,
  useNavigationType,
} from 'react-router-dom';
import { selectMetadataKeyByRegion } from 'reducers/selectors/metadata';
import useMenuRedirect from 'containers/Menu/hooks/useMenuRedirect';
import getFirstNode from 'utils/getFirstNode';
import { setRegisterUser } from 'utils/register';

const RegisterPage = ({ asset, translations }) => {
  const navigate = useNavigate();
  const location = useLocation();
  const navType = useNavigationType();
  const [searchParams] = useSearchParams();
  const STEPS = {
    EMAIL_FORM: 0,
    PASSWORD_FORM: 1,
  };

  const SUBMIT_TYPES = {
    previous: 'previous',
    next: 'next',
    terms: 'terms',
    terms_accept: 'terms_accept',
    promotion: 'promotion',
    email: 'email',
    validateEmail: 'validateEmail',
    login: 'login',
    cancel: 'cancel',
    submit: 'submit',
    done: 'done',
    loginemail: 'loginemail',
  };

  const {
    Onboarding_RegistrateRCU_Form_Logo_Mail: claroAdLogo,
    landing_head_logoClarovideo: cvLogo,
    landing_access_background: backgroundImage,
    Onboarding_RegistrateRCU_Form_Background_Mail: claroAdBackground,
  } = asset;

  const [activeStep, setActiveStep] = useState(STEPS.EMAIL_FORM);
  const [email, setEmail] = useState();
  const [emailValid, setEmailValid] = useState(true);
  const [country, setCountry] = useState(GetRegion());
  const [disclaimerIsShown, setDisclaimerIsShown] = useState(false);
  const [promotionsIsShown, setPromotionsIsShown] = useState(false);
  const [registerSubmitted, setRegisterSubmitted] = useState(false);
  const [registerError, setRegisterError] = useState(null);
  const [errorServiceGetUserInfo, setErrorServiceGetUserInfo] = useState(false);

  const dispatch = useDispatch();
  const claroAdEnable = useSelector(
    selectMetadataKeyByRegion('cv_advertising_config'),
  );

  const ssoRegister = useSelector(state => state.sso.register);
  const { firstNode } = useMenuRedirect();

  const { login, userModel } = useContext(UserContext);

  useEffect(
    () => {
      if (ssoRegister?.error && registerSubmitted) {
        setRegisterError(ssoRegister?.model?.code || ssoRegister?.model?.id);
        setRegisterSubmitted(false);
      }
    },
    [ssoRegister?.model],
  );

  const clearRegisterError = () => setRegisterError(null);

  const handleRegister = pass => {
    // e.preventDefault();
    dispatch(
      actionUserRegister({ email, region: country, password: pass, login }),
    );
  };

  const handleChatClicked = () => {
    window.open(translations.telmex_chat_link);
  };

  useEffect(() => {
    if (navType === 'POP' && location?.state) {
      navigate(-1);
    }
  }, []);

  useEffect(
    () => {
      if (userModel.is_user_logged_in) {
        setTimeout(() => {
          navigate(`/${GetRegion()}/${firstNode}${location.search}`, {
            ...location,
            replace: true
          });
        }, 100);
      }
    },
    [userModel],
  );

  useEffect(
    () => {
      if (navType === 'POP' && !location?.state) {
        processSubmitAction(SUBMIT_TYPES.email);
        setPromotionsIsShown(false);
        setDisclaimerIsShown(false);
      }
    },
    [location],
  );
  const sendMetrics = params => {
    dispatch(
      setMetricsEvent({
        tagManager: {
          ...params,
        },
      }),
    );

    dispatch(
      setMetricsEvent({
        type: m.EXECUTOR,
        success: true,
      }),
    );
  };

  const processSubmitAction = async (submitAction, values) => {
    // flag for know if isPromogate flow
    const isPromoGate = searchParams.get('isPromoGate');

    console.log('@submitAction',submitAction)

    switch (submitAction) {
      case SUBMIT_TYPES.previous:
        setActiveStep(activeStep - 1);
        break;
      case SUBMIT_TYPES.next:
        setActiveStep(activeStep + 1);
        break;
      case SUBMIT_TYPES.cancel:
        const anonymousUserComeFromPlayer = searchParams.get(
          'anonymousUserComeFromPlayer',
        );
        if (anonymousUserComeFromPlayer) {
          return navigate(
            `/${GetRegion()}/vcard/homeuser/${searchParams.get(
              'title_uri',
            )}/${searchParams.get('group_id')}`,
          );
        }

        const firstNode = getFirstNode();
        const pageToRedirect = claroAdEnable?.enable ? firstNode : 'landing';

        navigate({
          ...location,
          pathname: `/${GetRegion()}/${pageToRedirect}`,
          query: isPromoGate ? {} : location.query,
          search: isPromoGate ? '' : location.search,
        });
        break;
      case SUBMIT_TYPES.login:
        navigate({
          ...location,
          pathname: `/${GetRegion()}/login`,
          search: isPromoGate ? '' : location.search,
        });
        break;
      case SUBMIT_TYPES.promotion:
        setPromotionsIsShown(true);
        navigate(location.pathname, {
          ...location,
          search: location.search,
          state: { page_id: 3 },
        });
        break;
      case SUBMIT_TYPES.terms:
        setDisclaimerIsShown(true);
        navigate(location.pathname, {
          ...location,
          search: location.search,
          state: { page_id: 4 },
        });
        break;
      case SUBMIT_TYPES.terms_accept:
        break;
      case SUBMIT_TYPES.email:
        setActiveStep(STEPS.EMAIL_FORM);
        break;
      case SUBMIT_TYPES.validateEmail: {
        await dispatch(
          getUserInfoActions.getUserInfo({
            email: values.emailRegister,
          }),
        ).then((succeeded)=> {
        if (succeeded) {
          setActiveStep(STEPS.PASSWORD_FORM);
          navigate(`${location.pathname}${location.search}`, {
            ...location,
            state: { page_id: 3 },
          });

          setEmailValid(succeeded);
          setErrorServiceGetUserInfo(false)
        }else{
          setEmailValid(false);
          setErrorServiceGetUserInfo(false)
        }
        }).catch(()=>{
          setEmailValid(false);
          setErrorServiceGetUserInfo(true)
        });

        break;
      }
      case SUBMIT_TYPES.submit: {
        setRegisterSubmitted(true);
        setRegion(country);
        if (searchParams.get('anonymousUserComeFromPlayer')) {
          localStorage.setItem('anonymousUserComeFromPlayer', true);
        }
        localStorage.removeItem('defaultLiveChannel');
        const succeeded = await handleRegister(values.password);
            sessionStorage.setItem('hasFetchNav', false)
        await setRegisterUser();
        // Next code is useless, never executed
        if (succeeded) {
          sendMetrics({
            event: m.EVENT.SUCCESS_REGISTER,
            eventCategory: m.CATEGORY.LANDING,
            eventAction: m.ACTION.REGISTER,
            eventLabel: m.LABEL.EMAIL_SUCCESS,
          });
          navigate(`/${GetRegion()}/${firstNode}`, { ...location, replace: true });
        }
        break;
      }
      default:
        throw new Error(`Submit action ${submitAction} not supported`);
    }
  };

  const getActiveComponent = () => {
    switch (activeStep) {
      case STEPS.EMAIL_FORM:
        return (
          <EmailForm
            className="EmailForm"
            translations={translations}
            onChangeCountry={countrySelect => {
              sendMetrics({
                event: m.EVENT.REGISTER,
                eventCategory: m.CATEGORY.LANDING,
                eventAction: m.ACTION.REGISTER,
                eventLabel: m.LABEL.COUNTRY + countrySelect,
              });
            }}
            onShowTerms={() => {
              sendMetrics({
                event: m.EVENT.REGISTER,
                eventCategory: m.CATEGORY.LANDING,
                eventAction: m.ACTION.REGISTER,
                eventLabel: m.LABEL.TERMS,
              });
              processSubmitAction(SUBMIT_TYPES.terms);
            }}
            onAcceptTerms={() => {
              sendMetrics({
                event: m.EVENT.REGISTER,
                eventCategory: m.CATEGORY.LANDING,
                eventAction: m.ACTION.REGISTER,
                eventLabel: m.LABEL.TERMS_ACCEPT,
              });
              processSubmitAction(SUBMIT_TYPES.terms_accept);
            }}
            onCancelClicked={() => {
              sendMetrics({
                event: m.EVENT.REGISTER,
                eventCategory: m.CATEGORY.LANDING,
                eventAction: m.ACTION.REGISTER,
                eventLabel: m.LABEL.EMAIL_CANCEL,
              });
              processSubmitAction(SUBMIT_TYPES.cancel);
            }}
            onLoginClicked={() => {
              sendMetrics({
                event: m.EVENT.REGISTER,
                eventCategory: m.CATEGORY.LANDING,
                eventAction: m.ACTION.REGISTER,
                eventLabel: m.LABEL.LOG_IN,
              });
              processSubmitAction(SUBMIT_TYPES.login);
            }}
            onNextClicked={values => {
              console.log('values----',values)
              sendMetrics({
                event: m.EVENT.REGISTER,
                eventCategory: m.CATEGORY.LANDING,
                eventAction: m.ACTION.REGISTER,
                eventLabel: m.LABEL.EMAIL_NEXT,
              });
              setEmail(values.emailRegister);
              if (values.countrySelect) {
                setCountry(values.countrySelect.value || values.countrySelect);
              }
              processSubmitAction(SUBMIT_TYPES.validateEmail, values);
            }}
            onPromotionsClicked={() => {
              sendMetrics({
                event: m.EVENT.REGISTER,
                eventCategory: m.CATEGORY.LANDING,
                eventAction: m.ACTION.REGISTER,
                eventLabel: m.LABEL.PROMOTIONS,
              });
              processSubmitAction(SUBMIT_TYPES.promotion);
            }}
            emailValid={emailValid}
            onChatClicked={handleChatClicked}
            clearValidEmailError={() => {setEmailValid(true); setErrorServiceGetUserInfo(false) }}
            errorServiceGetUserInfo={errorServiceGetUserInfo}
          />
        );
      case STEPS.PASSWORD_FORM:
        return (
          <PasswordForm
            translations={translations}
            asset={asset}
            onCloseModal={clearRegisterError}
            onCancelClicked={() => {
              if (!registerSubmitted) {
                sendMetrics({
                  event: m.EVENT.REGISTER,
                  eventCategory: m.CATEGORY.LANDING,
                  eventAction: m.ACTION.REGISTER,
                  eventLabel: m.LABEL.EMAIL_PASSWORD_CANCEL,
                });
                processSubmitAction(SUBMIT_TYPES.cancel);
              }
            }}
            onNextClicked={values => {
              if (!registerSubmitted) {
                setRegisterSubmitted(true);
                sendMetrics({
                  event: m.EVENT.REGISTER,
                  eventCategory: m.CATEGORY.LANDING,
                  eventAction: m.ACTION.REGISTER,
                  eventLabel: m.LABEL.EMAIL_PASSWORD_NEXT,
                });
                processSubmitAction(SUBMIT_TYPES.submit, values);
              }
            }}
            registerError={registerError}
          />
        );
      default:
        throw new Error(`Step ${activeStep} not supported`);
    }
  };

  const renderHeader = () => {
    if (location?.state?.page_id === 4) {
      return (
        <div className="RegisterTermsAndConditions">
          <Button
            className="RegisterBackButton"
            onClick={() =>
              navigate(`/${GetRegion()}/register${location.search}`)
            }
          >
            <FaChevronLeft className="chevron" />
          </Button>
          <label>
            {translations.register_access_option_link_termsConditions}
          </label>
        </div>
      );
    }

    return (
      <header className={`registerHeader ${promotionsIsShown ? 'pomotionsActive' : ''}`}>
        <a
          className="logoHeader"
          href={`/${GetRegion()}/landing${location.search}${location.hash}`}
          onClick={event => {
            event.preventDefault();
            navigate(`/${GetRegion()}/landing${location.search}`, {
              ...location,
            });
          }}
        >
          <img src={claroAdEnable?.enable ? claroAdLogo : cvLogo} alt="logo" className={claroAdEnable?.enable ? 'claroAdLogo' : ''} />
        </a>
        <Button className="RegisterBackButton" onClick={() => navigate(-1)}>
          <FaChevronLeft className="chevron" />
          {translations.top_head_option_button_back}
        </Button>
      </header>
    );
  };

  return (
    <>
      {renderHeader()}
      {registerSubmitted && <Loader />}
      {promotionsIsShown && (
        <Promotions
          onClick={() => {
            sendMetrics({
              event: m.EVENT.REGISTER,
              eventCategory: m.CATEGORY.LANDING,
              eventAction: m.ACTION.REGISTER,
              eventLabel: m.LABEL.PROMOTIONS_OK,
            });
            setPromotionsIsShown(false);
            navigate(`/${GetRegion()}/register${location.search}`, {
              state: { page_id: 0 },
            });
          }}
        />
      )}
      {disclaimerIsShown && (
        <TermsAndConditions
          onClick={() => {
            sendMetrics({
              event: m.EVENT.REGISTER,
              eventCategory: m.CATEGORY.LANDING,
              eventAction: m.ACTION.REGISTER,
              eventLabel: m.LABEL.TERMS_BACK,
            });
            setDisclaimerIsShown(false);
            navigate(`/${GetRegion()}/register${location.search}`);
          }}
        />
      )}
      <div
        className="background"
        style={{
          backgroundImage: `url(${
            claroAdEnable?.enable ? claroAdBackground : backgroundImage
          })`,
        }}
      />
      <div className="registerPage">
        <div>{getActiveComponent()}</div>
      </div>
    </>
  );
};

RegisterPage.propTypes = {
  asset: PropTypes.object,
  onSubmit: PropTypes.func,
  onValidateEmail: PropTypes.func,
  translations: PropTypes.object,
};

const withSaga = injectSaga({ key: 'sso', saga });
const withReducer = injectReducer({ key: 'sso', reducer });

export default compose(
  withSaga,
  withReducer,
  WithApa,
)(RegisterPage);
